import { NgModule } from '@angular/core';
import { translationsEs } from '@assets/i18n/es';
import { translationChunksConfig } from '@spartacus/assets';
import { ConfigModule, I18nConfig } from '@spartacus/core';

// TODO: Agregar traducciones
const SPANISH_TRANSLATIONS = {
  es: translationsEs,
};

@NgModule({
  declarations: [],
  imports: [
    ConfigModule.withConfig({
      i18n: {
        resources: {
          // ...translations,
          ...SPANISH_TRANSLATIONS,
        },
        chunks: translationChunksConfig,
        fallbackLang: 'en',
      },
    } as I18nConfig),
  ],
})
export class I18nConfigurationModule {}
